export { default as AboutUsIcon } from "./AboutUsIcon";
export { default as ContactUsIcon } from "./ContactUsIcon";
export { default as CheckoutIcon } from "./CheckoutIcon";
export { default as UserIcon } from "./UserIcon";
export { default as CalenderIcon } from "./CalenderIcon";
export { default as BlogIcon } from "./BlogIcon";
export { default as TermsIcon } from "./TermsIcon";
export { default as CookiesIcon } from "./CookiesIcon";
export { default as PrivacyIcon } from "./PrivacyIcon";
export { default as WebsiteIcon } from "./WebsiteIcon";
